import { render, staticRenderFns } from "./GrcText.vue?vue&type=template&id=6197833b&"
import script from "./GrcText.vue?vue&type=script&lang=js&"
export * from "./GrcText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports